import { getDocsImportJobAPI } from '../common/services';
import useImportJob, { toCount } from './useImportJob';

// An import that changed nothing usually means the wrong file, so report counts.
const describe = ({ metadata = {} }) => {
    const total = toCount(metadata.totalRows);
    const parts = [`${toCount(metadata.updatedCount)} updated`];
    const unchanged = toCount(metadata.unchangedCount);
    const skipped = toCount(metadata.skippedCount);
    const errors = toCount(metadata.errorCount);
    if (unchanged) parts.push(`${unchanged} unchanged`);
    if (skipped) parts.push(`${skipped} skipped`);
    if (errors) parts.push(`${errors} with errors`);
    return { success: true, message: `Docs list updated. ${total} row${total === 1 ? '' : 's'} processed: ${parts.join(', ')}.` };
};

/**
 * Tracks one docs-list CSV import from its queued job to its result.
 *
 * @param {Function} options.onFinished - ({ success, message }) once the job ends
 */
const useDocsCsvImport = ({ onFinished } = {}) => useImportJob({
    fetchJob: getDocsImportJobAPI,
    describe,
    failureMessage: "The docs list couldn't be updated.",
    maxWaitMs: 5 * 60 * 1000,
    onFinished,
});

export default useDocsCsvImport;
